import LogoMark from "@/components/LogoMark";
import { Baby } from "lucide-react";

export const FRAME_OPTIONS = [
  { id: "none", label: "Polos", url: null, accent: "#2D231E" },
];

const FRAME_MAP = Object.fromEntries(FRAME_OPTIONS.map((f) => [f.id, f]));

export const TEXT_TEMPLATES = [
  {
    id: "lengkap",
    label: "Doa Lengkap",
    title: "Sertifikat Aqiqah",
    body: "Alhamdulillah Telah Melaksanakan Ibadah Sunnah Aqiqah Sesuai Syariat Islam, Semoga Allah Subhanahu Wa Ta'ala Menerima Ibadah Aqiqahnya Dan Memberikan Barokah Kepada Keluarga. Serta Ananda Menjadi Anak Yang Sholeh/Sholehah Berbakti Kepada Orang Tua, Juga Menjadi Penolong Agama Allah Subhanahu Wa Ta'ala, Aamiin Ya Rabbal 'Alamin",
  },
  {
    id: "ringkas",
    label: "Ringkas",
    title: "Sertifikat Aqiqah",
    body: "Telah dilaksanakan ibadah Aqiqah sesuai sunnah Rasulullah SAW. Semoga ananda menjadi anak yang sholeh/sholehah, sehat, cerdas, dan berbakti kepada kedua orang tua. Aamiin Ya Rabbal 'Alamin.",
  },
  {
    id: "syukur",
    label: "Ungkapan Syukur",
    title: "Sertifikat Aqiqah",
    body: "Dengan penuh rasa syukur ke hadirat Allah Subhanahu Wa Ta'ala, telah ditunaikan ibadah Aqiqah. Semoga menjadi keberkahan bagi ananda dan keluarga, serta menjadikan ananda insan yang bertakwa dan bermanfaat bagi sesama. Aamiin.",
  },
];

const longDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
};

export default function CertificateCanvas({ id, cfg, data }) {
  const { title, body, address, phone, showPhoto = true } = cfg;
  const isCustom = cfg.frame === "custom";
  const frame = FRAME_MAP[cfg.frame] || FRAME_MAP.none;
  const frameUrl = isCustom ? cfg.customFrame : frame.url;
  const accent = isCustom ? "#2D231E" : frame.accent;
  const childName = data.childName || "Ananda Fulan";
  const father = data.father || "";
  const mother = data.mother || "";
  const parents = [father, mother].filter(Boolean).join(" Dan ") || "-";

  return (
    <div id={id} className="relative overflow-hidden bg-white" style={{ width: "768px", height: "960px", fontFamily: "Manrope, sans-serif" }}>
      {frameUrl && (
        <img src={frameUrl} alt="" className="pointer-events-none absolute inset-0 h-full w-full" style={{ objectFit: "fill" }} crossOrigin="anonymous" />
      )}

      <div className={`relative z-10 flex h-full flex-col items-center px-[70px] ${showPhoto ? "pt-[80px]" : "justify-center pb-[110px]"}`}>
        {/* Photo */}
        {showPhoto && (
          <div className="rounded-[4px] bg-white" style={{ boxShadow: "0 12px 26px rgba(45,35,30,0.28)" }}>
            {data.photoUrl ? (
              <img src={data.photoUrl} alt={childName} className="h-[248px] w-[202px] rounded-[3px] object-cover" crossOrigin="anonymous" />
            ) : (
              <div className="flex h-[248px] w-[202px] items-center justify-center rounded-[3px] bg-[#F4F0EA]">
                <Baby className="h-20 w-20 text-brand-gold" />
              </div>
            )}
          </div>
        )}

        {/* Title */}
        <h1 className={`text-center font-serif text-[24px] font-bold uppercase tracking-wide text-[#1a1a1a] ${showPhoto ? "mt-5" : ""}`}>{title}</h1>
        <p className="mt-0.5 font-serif text-[18px] font-bold text-[#1a1a1a]">Diberikan Kepada :</p>

        {/* Name */}
        <h2 className="mt-2 text-center font-serif text-[34px] font-medium italic uppercase leading-none tracking-[0.02em] text-[#1a1a1a]">{childName}</h2>

        {/* Detail */}
        <div className="mt-2 space-y-0.5 text-center font-serif text-[19px] font-bold leading-snug text-[#1a1a1a]">
          <p>Tanggal Aqiqah : {longDate(data.eventDate)}</p>
          <p>Tanggal Lahir : {data.birth || "-"}</p>
          <p>Nama Orang Tua :</p>
          <p>{parents}</p>
        </div>

        {/* Body */}
        <p className="mx-auto mt-3 max-w-[560px] text-justify font-serif text-[15px] italic leading-relaxed text-[#2a2a2a]">{body}</p>
      </div>

      {/* Footer */}
      <div className="absolute bottom-[80px] left-[76px] right-[76px] z-10 flex items-center gap-4">
        <LogoMark size={48} plain className="shrink-0 shadow-none" />
        <div className="leading-tight" style={{ color: accent }}>
          <p className="font-sans text-[20px] font-extrabold uppercase tracking-wide">Rizqia Aqiqah</p>
          <p className="text-[11.5px] font-bold italic">{address}</p>
          <p className="text-[11.5px] font-bold italic">Telp/WA : {phone}</p>
        </div>
      </div>
    </div>
  );
}
